document.addEventListener('DOMContentLoaded', function(){
  document.querySelectorAll('.chip').forEach(chip=>{
    chip.addEventListener('click',()=>{
      document.querySelectorAll('.chip').forEach(c=>c.classList.remove('active'));
      chip.classList.add('active');
    });
  });

  var tradeInForm = document.getElementById('tradeInForm');
  if (tradeInForm) {
    tradeInForm.addEventListener('submit', function(e){
      e.preventDefault();
      const year = parseInt(document.getElementById('ti-year').value,10);
      const base = parseFloat(document.getElementById('ti-make').value);
      const km = parseFloat(document.getElementById('ti-km').value) || 0;
      const condMult = parseFloat(document.getElementById('ti-cond').value);

      const age = Math.max(0, 2026 - year);
      const ageDepreciation = Math.pow(0.89, age);
      const expectedKm = age * 18000;
      const kmDelta = km - expectedKm;
      const kmAdj = 1 - Math.max(-0.15, Math.min(0.15, kmDelta / 300000));

      let value = base * ageDepreciation * kmAdj * condMult;
      value = Math.max(1500, Math.round(value / 50) * 50);

      document.getElementById('ti-value').textContent = '$' + value.toLocaleString('en-CA');
      document.getElementById('ti-result').classList.add('show');
    });
  }

  var financeForm = document.getElementById('financeForm');
  if (financeForm) {
    financeForm.addEventListener('submit', function(e){
      e.preventDefault();
      const price = parseFloat(document.getElementById('fi-price').value) || 0;
      const down = parseFloat(document.getElementById('fi-down').value) || 0;
      const termMonths = parseInt(document.getElementById('fi-term').value,10);
      const annualRate = parseFloat(document.getElementById('fi-credit').value);

      const principal = Math.max(0, price - down);
      const monthlyRate = annualRate / 12;
      let payment;
      if (monthlyRate === 0) {
        payment = principal / termMonths;
      } else {
        payment = principal * (monthlyRate * Math.pow(1+monthlyRate, termMonths)) / (Math.pow(1+monthlyRate, termMonths) - 1);
      }
      payment = Math.round(payment);

      const eligible = price > 0 && price <= 60000;
      document.getElementById('fi-value').textContent = '$' + payment.toLocaleString('en-CA') + ' / mo';
      document.getElementById('fi-note').textContent = 'Based on a ' + termMonths + '-month term at an estimated ' + (annualRate*100).toFixed(1) + '% APR. Rate shown is illustrative — your actual rate depends on lender approval.';
      const flag = document.getElementById('fi-flag');
      if (eligible){
        flag.textContent = 'Vehicle eligible for TRX financing';
        flag.className = 'result-flag eligible';
      } else {
        flag.textContent = 'Outside standard financing band — speak to our team';
        flag.className = 'result-flag not-eligible';
      }
      document.getElementById('fi-result').classList.add('show');
    });
  }
});
